import { Event, EventResponse } from 'src/types/types';

export const eventResponseTransform = (event: EventResponse): Event => ({
  address: {
    city: event.venue.address.city,
    country: event.venue.address.country,
    latLng: {
      lat: +event?.venue?.latitude,
      lng: +event?.venue?.longitude,
    },
    postalCode: event?.venue?.address?.postal_code,
    state: event?.venue?.address?.region,
    street: event?.venue?.address?.address_1,
  },
  id: event.id,
  title: event.title,
  description: event.description || '',
  location: event?.venue?.multi_line_address_display,
  dateStart: event.start_date,
  dateEnd: event.end_date,
  allDayEvent: event.all_day_event,
  repeatingDays: event.repeating_days,
  occurrences: event.occurrences,
  availableOccurrences: event.available_occurrences,
  dateTBD: event.date_tbd,
  isOnline: event.is_online,
  isPrivate: event.is_private,
  type: event.type,
  currency: event.currency,
  accountId: event.account_id,
  repeat: event.is_repeating_event,
  isSeriesParent: event.is_series_parent,
  seriesId: event.series_id,
  repeatOn: event.repeat_on,
  timezone: event.timezone,
  image_url: event.image_url,
  url: event.url,
  ticket_url: event.ticket_url,
  status: event.status,
  questions: event.questions,
  useCheckoutForm: event.use_checkout_form,
  occurrenceUniqueZoomLink: event.unique_recurring_zoom_link,
  secondaryImageUrls: event.secondary_image_urls,
  promotionalImageUrls: event.promotional_image_urls,
  descriptionThumbnailUrls: event.description_thumbnail_urls,
  venueEmail: event.venue_email,
  venueName: event.venue_name,
  venuePhone: event.venue_phone,
  venueWebsite: event.venue_website,
  additionalProperties: event.additional_properties,
  eventSetup: event.event_setup,
  confirmationMessage: event.confirmation_message,
  tags: event.tags,
  includeEventDataUrl: event.include_event_data_url,
  externalUrlLinkToHostedPage: event.external_url_link_to_hosted_page,
  multiSessionEvent: event.multi_session_event,
  unlimitedCapacity: event.unlimited_capacity,
  eventCapacity: event.event_capacity,
  eventType: event.event_type,
  category: event.category,
  subcategory: event.subcategory,
  salesTax: event.sales_tax,
  isMultiDay: event.is_multi_day,
  isTimeBased: event.is_time_based,
  overrideParentTickets: event.override_parent_tickets,
  createdAt: event.created_at,
  eventPageUrl: event.event_page_url,
  eventLandingPageUrl: event.landing_page_url,
  privacyHideEvent: event.privacy_hide_event,
  privacyAccessCodeEnabled: event.privacy_access_code_enabled,
  privacyAccessCode: event.privacy_access_code,
  enableWaitlist: event.enable_waitlist,
  waitlistConfirmationMessage: event.waitlist_confirmation_message,
  waitlistEnableCommunication: event.waitlist_enable_communication,
  waitlistTriggerEventCapacity: event.waitlist_trigger_event_capacity,
  waitlistTriggerTicketsSoldOut: event.waitlist_trigger_tickets_sold_out,
  waitlistCallToAction: event.waitlist_call_to_action,
  waitlistDescription: event.waitlist_description,
  requiresApproval: event.requires_approval,
  attendeeMetrics: event.attendee_metrics,
  customSubdomain: event.custom_subdomain,
  subdomain: event.subdomain,
  tickets: event.tickets,
  answers: event.answers,
  _design_eventAttendeeButtonText: event._design_event_attendee_button_text,
  _design_eventPageAttendeeButtonText: event._design_event_page_attendee_button_text,
  _design_eventPageSiteName: event._design_event_page_site_name,
  campaigns: event.campaigns,
});
